module.exports = __webpack_public_path__ + "img/home3.24de588f.jpg";